import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { CBox_AdminLockerData } from "@server/services/cbox/public/api/v1/resources/internal/locker/types";
import { ButtonModule } from "primeng/button";
import { DropdownModule } from "primeng/dropdown";

@Component({
  selector: "app-cbox-admin-locker-equipment-status-update-dialog",
  templateUrl: "./cbox-admin-locker-equipment-status-update-dialog.component.html",
  styleUrls: ["./cbox-admin-locker-equipment-status-update-dialog.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    DropdownModule,
    FormsModule,
    ButtonModule,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose
  ]
})

export class CBoxAdminLockerEquipmentStatusUpdateDialogComponent implements OnInit {

  stateOptions = signal([
    { label: "Activ",       value: "OK"      },
    { label: "Dezactivat",  value: "NOT_OK"  },
    { label: "Necunoscut",  value: "UNKNOWN" }
  ]);

  printerStateOptions = signal([
    { label: "Activ",       value: "OK"      },
    { label: "Dezactivat",  value: "NOT_OK"  },
    { label: "Necunoscut",  value: "UNKNOWN" },
    { label: "Fara hartie",  value: "OUT_OF_PAPER" }
  ])

  constructor(
    private dialogRef: MatDialogRef<CBoxAdminLockerEquipmentStatusUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public lockerData: CBox_AdminLockerData) { }

  ngOnInit() {}

  update(): void {
    this.dialogRef.close(this.lockerData);
  }

  log(): void {
    console.log(this.lockerData.options, "LOCKER OPTIONS");
  }
}